// ── RrTypeChip — the response-type chip (SS2B-2b, Phase 1) ────────────────────
//
// Hue + glyph on a coloured left edge, with the stage as a suffix INSIDE the chip (muted = planned,
// lit = implemented) — NOT a separate badge, NOT a second row (honesty anchor 3). Always rendered
// LEFT of the StatusBadge; the pair wraps together and never splits ("what response, then where it
// is"). Presentation only — reads planned_response_type + the derived stage already in the payload.
// The hue is data-driven (inline style) because the type chip is its own mechanism; it borrows no
// StatusBadge colour.

import { deriveStage, RR_TYPE_SPECS, type RrTypeSource } from './rrPresentation';
import type { RiskResponseType } from '@/api/types/risk-acceptance.types';

export function RrTypeChip({ entry }: { entry: RrTypeSource }) {
  const spec = RR_TYPE_SPECS[entry.planned_response_type as RiskResponseType] ?? RR_TYPE_SPECS.accept;
  const stage = deriveStage(entry);
  const implemented = stage === 'implemented';

  return (
    <span
      className="inline-flex items-center gap-1.5 whitespace-nowrap rounded border border-border-subtle bg-bg-surface-2 py-0.5 pl-1.5 pr-2 text-xs font-semibold text-text-secondary"
      style={{ borderLeftColor: spec.hue, borderLeftWidth: 3 }}
    >
      <span className="font-bold" style={{ color: spec.hue }}>{spec.glyph}</span>
      {spec.name}
      <span
        className="font-normal"
        style={{ color: implemented ? spec.hue : undefined }}
      >
        · {stage}
      </span>
    </span>
  );
}
